import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { map, catchError, switchMap, finalize } from 'rxjs/operators';

import { PrizeRequestsActions } from '../_actions/prize-requests.actions';
import { LayoutActions } from '../_actions/layout.actions';
import { PrizeRequestsService } from '../../_services/prize-requests.service';
import { LayoutUtilsServices, MessageType } from '../../_services/layout-utils.services';
import { AppState } from '../index';

@Injectable()
export class PrizeRequestsEffects {
  constructor(
    private actions$: Actions,
    private prizeRequestsService: PrizeRequestsService,
    private layoutUtilsService: LayoutUtilsServices,
    private store: Store<AppState>
  ) {}

  /**
   * Effect: Crear solicitud
   */
  createRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PrizeRequestsActions.createRequest),
      switchMap((action) => {
        this.store.dispatch(LayoutActions.spinnerTrigger({ show: true }));
        return this.prizeRequestsService.createRequest({
          prize_id: action.prize_id,
          full_name: action.full_name,
          delivery_address: action.delivery_address,
          city: action.city,
          phone: action.phone,
          email: action.email,
          additional_notes: action.additional_notes,
          terms_accepted: action.terms_accepted,
        }).pipe(
          finalize(() =>
            this.store.dispatch(LayoutActions.spinnerTrigger({ show: false }))
          ),
          map((request) =>
            PrizeRequestsActions.createRequestSuccess({ request })
          ),
          catchError(({ error }) => {
            const errorMessage = Array.isArray(error?.message)
              ? error.message.join(', ')
              : error?.message || 'Error al crear la solicitud de canje';

            this.layoutUtilsService.showNotification({
              type: MessageType.Danger,
              message: errorMessage
            });

            return of(PrizeRequestsActions.createRequestFailure({ error }));
          })
        );
      })
    )
  );

  /**
   * Effect: Cargar mis solicitudes
   */
  loadMyRequests$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PrizeRequestsActions.loadMyRequests),
      switchMap((action) =>
        this.prizeRequestsService.getMyRequests(action.filters).pipe(
          map((response) =>
            PrizeRequestsActions.loadMyRequestsSuccess({
              requests: response.data,
              total: response.total,
            })
          ),
          catchError((error) =>
            of(PrizeRequestsActions.loadMyRequestsFailure({ error }))
          )
        )
      )
    )
  );

  /**
   * Effect: Cargar detalle de solicitud
   */
  loadRequestDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PrizeRequestsActions.loadRequestDetail),
      switchMap((action) =>
        this.prizeRequestsService.getRequestDetail(action.id).pipe(
          map((request) =>
            PrizeRequestsActions.loadRequestDetailSuccess({ request })
          ),
          catchError((error) =>
            of(PrizeRequestsActions.loadRequestDetailFailure({ error }))
          )
        )
      )
    )
  );
}
